import { AnyAction, SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query/react';
import { ErrorOption } from 'react-hook-form';
import { ServerError, ServerErrorAction } from '../slices/types';
import { InlineError } from '../hooks/useErrorHandling';

export const DEFAULT_ERROR = 'Something went wrong, try again later';

export const isServerError = (data: unknown): data is ServerError =>
    typeof data === 'object' && data !== null && ('errorCode' in data || 'error' in data);

export const isFetchBaseQueryError = (error: unknown): error is FetchBaseQueryError =>
    typeof error === 'object' && error !== null && 'data' in error && 'status' in error;

export const isServerErrorAction = (action: AnyAction): action is ServerErrorAction => {
    const isFetchBaseQueryErr = isFetchBaseQueryError(action?.payload);
    const isServerErr = isServerError(action?.payload?.data);
    return isFetchBaseQueryErr && isServerErr;
};

export function serverError(error: InlineError): ErrorOption {
    return { type: 'server', message: error.message };
}

/**
 * @deprecated Don't use this, use serverError instead
 */
export function oldServerError(error: FetchBaseQueryError | SerializedError): ErrorOption {
    return { type: 'server', message: serverErrorMessage(error) };
}

export function serverErrorMessage(error: FetchBaseQueryError | SerializedError) {
    let errorMessage;
    if (isFetchBaseQueryError(error)) {
        const serverError = error.data as ServerError;
        errorMessage = serverError.error;
    }
    return errorMessage || DEFAULT_ERROR;
}
